import { apiFetch } from "../../util/MainApiFetch";

export async function resetPasswordUser(body) {
  const fetchOptions = {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(body),
  };
  return await apiFetch("/user/auth", {}, fetchOptions);
}

export async function unlockUserPassword(body) {
  const fetchOptions = {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(body),
  };
  return await apiFetch("/user/auth", {}, fetchOptions);
}

export async function unlockExpiredPassword(body) {
  const fetchOptions = {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(body),
  };
  return await apiFetch(
    "/user/auth/current_password_expired",
    {},
    fetchOptions
  );
}
